import { createFileRoute } from "@tanstack/react-router";
import { useShoppingListItems } from "../../hooks/useShoppingListList";
import { useForm } from "react-hook-form";
import { useShoppingListItemUpdate } from "../../hooks/useShoppingListUpdate";

export const Route = createFileRoute("/app/shoppinglist")({
  component: ShoppingListPage,
});

function ShoppingListPage() {
  const { shoppingListQuery } = useShoppingListItems();
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm<{ item_name: string }>();
  const { updateShoppingListItem } = useShoppingListItemUpdate();

  if (!shoppingListQuery.isSuccess) {
    return <div>loading</div>;
  }
  const shoppingList = shoppingListQuery.data[0];
  return (
    <div>
      <ul>
        {shoppingList.entries.map((item, listPosition) => {
          return (
            <li key={crypto.randomUUID()}>
              <div>
                <span>
                  {item.item_name} - {item.in_cart ? "in cart" : "not in cart"}
                </span>
                <button
                  onClick={() =>
                    updateShoppingListItem.mutateAsync({
                      updateShoppingListItemDto: {
                        id: shoppingList.id,
                        entries: shoppingList.entries
                          .slice()
                          .filter((_, idx) => idx !== listPosition),
                      },
                    })
                  }
                >
                  delete
                </button>
                <button
                  onClick={() =>
                    updateShoppingListItem.mutateAsync({
                      updateShoppingListItemDto: {
                        id: shoppingList.id,
                        entries: shoppingList.entries
                          .slice()
                          .map((arg, idx) => {
                            return {
                              item_name: arg.item_name,
                              in_cart:
                                idx === listPosition
                                  ? !arg.in_cart
                                  : arg.in_cart,
                            };
                          }),
                      },
                    })
                  }
                >
                  cart toggle
                </button>
              </div>
            </li>
          );
        })}
      </ul>
      <form
        onSubmit={handleSubmit(async (createShoppingListItemDto) => {
          await updateShoppingListItem.mutateAsync({
            updateShoppingListItemDto: {
              id: shoppingList.id,
              entries: [
                ...shoppingList.entries,
                {
                  ...createShoppingListItemDto,
                  in_cart: false,
                },
              ],
            },
          });
          reset();
        })}
      >
        <input
          type="text"
          {...register("item_name", {
            required: true,
            minLength: 1,
          })}
        ></input>
        {errors.item_name &&
          ["minLength", "required"].includes(errors.item_name.type) && (
            <span className="text-red-400">
              Must have at least one character
            </span>
          )}
        <input type="submit"></input>
      </form>
    </div>
  );
}
